import React, {ReactNode, useCallback} from "react";

import {useAppState} from "@stores/AppStateContext";

import {ModalBase} from "../../../ui/screens/modals/components/ModalBase";
import {RocketLaunch} from "../../../ui/components/icons/RocketLaunchIcon";

export interface SuccessModalProps {
    titleText: ReactNode;
    text?: string;
    addition?: ReactNode;
}

import './SuccessModal.css';


export const SuccessModal = (
    {
        titleText,
        text,
        addition
    }: SuccessModalProps
) => {
    const appState = useAppState();
    const handleClose = useCallback(() => {
        appState.setModal(null);
    }, []);

    return (
        <ModalBase
            open={true}
            header={''}
            onClose={handleClose}
            maxWidth={596}
        >
            <>
                <div className="SuccessModal-icon-row">
                    <RocketLaunch className="icon--success" size={48}/>
                </div>
                <div className="SuccessModal-subtitle body-large-bold">
                    {titleText}
                </div>
                {text &&  (
                    <div className="SuccessModal-text">
                        {text}
                    </div>
                )}
                {addition}
            </>
        </ModalBase>
    )
}
